"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = ["disabled"];
const _hoisted_2 = { key: 1 };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _directive_i18n = (0, vue_1.resolveDirective)("i18n");
    return (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("button", {
        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('click'))),
        class: (0, vue_1.normalizeClass)(["btn", _ctx.outerClass]),
        disabled: _ctx.isDisabled
    }, [
        (_ctx.hasIcon)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", {
                key: 0,
                class: (0, vue_1.normalizeClass)(["icon", _ctx.iconClass]),
                "data-test": "icon"
            }, null, 2))
            : ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", _hoisted_2, (0, vue_1.toDisplayString)(_ctx.buttonText), 1))
    ], 10, _hoisted_1)), [
        [_directive_i18n]
    ]);
}
